var _defs, _path, _use, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordEyeVisibleNotCrossed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-.9%",
    y: "-4.5%",
    width: "101.7%",
    height: "109.1%",
    filterUnits: "objectBoundingBox",
    id: "c"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161494755 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    x: 0,
    y: 0,
    width: 230,
    height: 44,
    rx: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.005C0 5.375 5.363 0 11.994 0h246.012C264.63 0 270 5.37 270 12.005v293.99c0 6.63-5.363 12.005-11.994 12.005H11.994C5.37 318 0 312.63 0 305.995z",
    id: "a"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-273-356h375v667h-375z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M0 0h376v667H0z",
    transform: "translate(-273 -356)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-220 -205)"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    style: {
      mixBlendMode: "soft-light"
    },
    xlinkHref: "#a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-200 -12)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#b"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.478 9.274q-1.612-2.502-4.04-3.743.647 1.102.647 2.386 0 1.961-1.394 3.355-1.395 1.395-3.356 1.395t-3.356-1.395-1.394-3.355q0-1.283.647-2.386-2.428 1.24-4.04 3.743 1.41 2.174 3.536 3.462a8.73 8.73 0 0 0 4.607 1.288 8.73 8.73 0 0 0 4.607-1.288q2.126-1.29 3.536-3.462m-7.783-3.711a.5.5 0 0 0 .149-.36.5.5 0 0 0-.149-.361.5.5 0 0 0-.36-.149q-1.326 0-2.274.95-.95.948-.95 2.274 0 .211.15.36a.5.5 0 0 0 .36.149.5.5 0 0 0 .36-.149.5.5 0 0 0 .149-.36q0-.912.646-1.559.648-.647 1.559-.647a.5.5 0 0 0 .36-.148m8.928 2.98q.212.37.212.73 0 .361-.212.732a11.25 11.25 0 0 1-3.992 3.907q-2.508 1.47-5.296 1.469t-5.296-1.474-3.992-3.902a1.47 1.47 0 0 1-.212-.731q0-.36.212-.732Q2.531 6.115 5.039 4.64q2.508-1.473 5.296-1.473t5.296 1.473 3.992 3.902",
    fill: "#00B1D1",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEyeVisibleNotCrossed);
export default __webpack_public_path__ + "static/media/password-eye-visible-not-crossed.f1bb66c8aa1f1146acf8039a3a961779.svg";
export { ForwardRef as ReactComponent };